// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y_-xc","tabsBox":"styles_tabsBox__zfQKQ","createButton":"styles_createButton__ZNOrf"};